// eslint-disable-next-line @typescript-eslint/typedef
export const ERROR_REPORTER_SEVERITY = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
} as const;

// eslint-disable-next-line @typescript-eslint/typedef
export const ERROR_REPORTER_BREADCRUMB_TYPE = {
    ERROR: 'error',
    LOG: 'log',
    MANUAL: 'manual',
    NAVIGATION: 'navigation',
    PROCESS: 'process',
    REQUEST: 'request',
    STATE: 'state',
    USER: 'user',
} as const;

export type ErrorReporterSeverity =
    (typeof ERROR_REPORTER_SEVERITY)[keyof typeof ERROR_REPORTER_SEVERITY];
export type ErrorReporterBreadcrumbType =
    (typeof ERROR_REPORTER_BREADCRUMB_TYPE)[keyof typeof ERROR_REPORTER_BREADCRUMB_TYPE];

export interface ErrorReporterMetadata {
    [key: string]: unknown;
}

export interface ErrorReporterOptions {
    severity?: ErrorReporterSeverity;
    context?: string;
    metadata?: ErrorReporterMetadata;
}

export interface ErrorReporterUser {
    id?: string;
    email?: string;
    name?: string;
}

export interface IErrorReporterService {
    start(): void;
    report(error: unknown, options?: ErrorReporterOptions): void;
    setUser(user: ErrorReporterUser | null): void;
    leaveBreadcrumb(
        message: string,
        metadata?: ErrorReporterMetadata,
        type?: ErrorReporterBreadcrumbType,
    ): void;
}
